"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M17 4h2v16h-2zM2 2v20h13V2zm19 16h1.5V6H21z"
}), 'WebStoriesSharp');